module.exports = __webpack_public_path__ + "img/joost.da09767f.jpg";